<template>
  <div class="actions-dropdown">
    <b-dropdown
      no-caret
      variant="link"
      :toggle-class="`text-decoration-none shadow-none ${toggleClass}`"
      :content-class="`outline-none shadow-none ${contentClass}`"
      :left="left"
      :right="right"
      :disabled="disabled"
    >
      <template #button-content>
        <slot name="button-custom-content" v-bind:item="item">
          <snow-button
            size="sm"
            variant="borderless"
            icon="ph ph-dots-three-vertical"
            role="button"
          />
        </slot>
      </template>
      <b-dropdown-item
        v-for="(action, index) in actions"
        :key="index"
        @click.stop="onClickItem(action, index)"
      >
        <h5
          class="text-semibold"
          :class="action.class"
          v-html="action.text"
        ></h5>
        <snow-dialog
          v-if="action.confirmation.enable"
          icon="ph ph-warning-circle"
          secondaryButtonText="Cancelar"
          v-model="visible[index]"
          :ButtonText="action.confirmation.submitText"
          :text="action.confirmation.text"
          @action="submitConfirm(action, index)"
        />
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    },
    left: {
      type: Boolean,
      default: true
    },
    right: {
      type: Boolean,
      default: false
    },
    toggleClass: {
      type: String,
      default: ""
    },
    contentClass: {
      type: String,
      default: ""
    },
    buttonClasses: {
      type: [String, Object],
      default: "btn btn-sm btn-square-sm p-5"
    },
    actions: {
      type: Array,
      default: () => [
        {
          icon: "fa-solid fa-pen",
          text: "Editar",
          class: "",
          event: "edit"
        }
      ]
    }
  },
  data() {
    return {
      modalOptions: false,
      visible: {
        ...Array(this.actions.length).fill(false)
      }
    };
  },
  methods: {
    onOpen(e) {
      e.preventDefault();
      this.modalOptions = true;
    },
    onClickItem(action, index) {
      if (action.confirmation.enable) {
        this.visible[index] = true;
        return;
      }

      if (action.eventOnClick) {
        action.eventOnClick();
      } else {
        this.$emit(action.event);
      }
      this.modalOptions = false;
    },
    submitConfirm(action, index) {
      if (action.eventOnClick) {
        action.eventOnClick();
      } else {
        this.$emit(action.event);
      }

      this.visible[index] = false;
      this.modalOptions = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.actions-dropdown {
  ::v-deep .dropdown-menu {
    padding: 16px;
    border-radius: 16px;
    border: 1px solid var(--dark-10);
  }

  ::v-deep .dropdown-item {
    padding: 8px;
    border-radius: 10px;
  }

  ::v-deep .dropdown-item:hover {
    background: var(--bg-2);
  }
}
</style>
